import { render, staticRenderFns } from "./SwitchAccounts.vue?vue&type=template&id=119c0f28&scoped=true&"
import script from "./SwitchAccounts.vue?vue&type=script&lang=js&"
export * from "./SwitchAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAccounts.vue?vue&type=style&index=0&id=119c0f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119c0f28",
  null
  
)

export default component.exports